module.exports = __webpack_public_path__ + "static/media/App.2d8d20e5.less";